import React, { useState } from 'react';
import ConfirmProcess from './components/ConfirmProcess';
import RequestSent from './RequestSent';
import SignatureModal from './SignatureModal';
import { Certificate } from '../../entities/certificate';
import {
	NewStatus,
	StatusChangeReason,
	updateCertificate,
} from '../../use-cases/update-certificate';
import { EditActionResult } from './my-signatures';
import { getNewStatusHumanizedNamePastTense } from '@/utils/get-new-status-humanized-name';
import notifyHB from '@/config/notifyHB';

type EditSignatureModalProps = {
	certificate: Certificate;
	handleClose: () => void;
	refreshCertificates: () => Promise<void>;
	onEditComplete: (result: EditActionResult) => void;
};

export type Step =
	| {
			step: 'start';
	  }
	| {
			step: 'confirmation' | 'otp';
			newStatus: NewStatus;
	  }
	// | {
	// step: 'processing';
	// otp: string;
	// reason?: StatusChangeReason;
	// }
	| {
			step: 'end';
	  };

const EditSignatureBody: React.FC<EditSignatureModalProps> = ({
	certificate,
	handleClose,
	refreshCertificates,
	onEditComplete,
}) => {
	const [componentStep, setComponentStep] = useState<Step>({ step: 'start' });
	const [isUpdatingCertificate, setIsUpdatingCertificate] = useState(false);

	let step;

	switch (componentStep.step) {
		case 'start':
			step = (
				<SignatureModal
					certificate={certificate}
					handleClose={handleClose}
					setComponentState={setComponentStep}
					refreshCertificates={refreshCertificates}
				/>
			);
			break;

		case 'confirmation':
			step = (
				<ConfirmProcess
					certificateName={certificate.name}
					newStatus={componentStep.newStatus}
					isUpdating={isUpdatingCertificate}
					onConfirm={(statusChangeReason?: StatusChangeReason) => {
						setIsUpdatingCertificate(true);
						// setComponentStep({ step: 'processing' });
						updateCertificate(
							certificate.certificate_id,
							componentStep.newStatus,
							statusChangeReason,
						)
							.then(() => {
								onEditComplete({
									status: 'success',
									description: `¡Firma ${certificate.name} fue ${getNewStatusHumanizedNamePastTense(componentStep.newStatus)} exitosamente!`,
								});
								refreshCertificates().catch((error) =>
									notifyHB(
										'my-certificates',
										'EditSignatureBody',
										error,
									),
								);
							})
							.catch((error) => {
								onEditComplete({
									status: 'error',
									description:
										'No pudimos actualizar la firma. Intenta de nuevo más tarde',
								});
								notifyHB(
									'my-certificates',
									'EditySignatureBody',
									`Hubo un error al enviar la solicitud ${error}`,
								);
							})
							.finally(() => {
								// setComponentStep({ step: 'end' });
								setIsUpdatingCertificate(false);
								handleClose();
							});
					}}
					onReject={() => {
						setComponentStep({ step: 'start' });
					}}
				/>
			);
			break;
		case 'end':
			step = <RequestSent handleClose={handleClose} />;
			break;
	}

	return <>{step}</>;
};

export default EditSignatureBody;
